import type {
  RoboticMowersSummaryResponse,
  RoboticMowersProgressResponse,
  RoboticMowerMissionsResponse,
} from '@fleet-bffs/api-contract';
import { bffWebApi, TagTypes } from '~/api';

const roboticMowersApi = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getRoboticMowers: build.query<RoboticMowersSummaryResponse, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/robotic-mowers/summary`,
      }),
    }),
    getRoboticMowersMissionsProgress: build.query<RoboticMowersProgressResponse, void>({
      query: () => ({
        url: `${process.env.ENDPOINT_BFF}/robotic-mowers/progress`,
        method: 'GET',
      }),
    }),
    getRoboticMowerMissions: build.query<RoboticMowerMissionsResponse, string>({
      query: (iprId) => ({
        url: `${process.env.ENDPOINT_BFF}/robotic-mowers/missions/${iprId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, iprId) => [{ type: TagTypes.MachineAreaDetails, id: iprId }],
    }),
  }),
});

export const {
  useGetRoboticMowersQuery,
  useLazyGetRoboticMowersMissionsProgressQuery,
  useLazyGetRoboticMowerMissionsQuery,
  useGetRoboticMowerMissionsQuery,
} = roboticMowersApi;

export default roboticMowersApi;
